"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Logo = _interopRequireDefault(require("../Logo"));

var _LoadingDots = _interopRequireDefault(require("../LoadingDots"));

var _Quips = _interopRequireDefault(require("../Quips"));

var _GraderActionCreator = _interopRequireDefault(require("../../actions/GraderActionCreator"));

var _AppConstants = require("../../constants/AppConstants");

var _Paths = require("../../constants/Paths");

var _History = require("../../util/History");

var _default = function _default(_ref) {
  var websiteUrl = _ref.websiteUrl;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    var timer = setInterval(function () {
      return dispatch(_GraderActionCreator.default.getGrade(websiteUrl));
    }, 1000);
    var limitTimer = setTimeout(function () {
      return (0, _History.navigateTo)(_Paths.ERROR);
    }, _AppConstants.POLL_TIME_LIMIT);
    return function () {
      clearTimeout(limitTimer);
      clearInterval(timer);
    };
  }, []);
  return _react.default.createElement("div", {
    className: "loading-page",
    "data-reagan-selector": "loading-page"
  }, _react.default.createElement("div", {
    className: "loading-radial-container"
  }, _react.default.createElement("div", {
    className: "loading-text",
    "data-reagan-selector": "loading-text"
  }, _react.default.createElement(_Logo.default, null), _react.default.createElement("div", {
    className: "title"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "meta.title"
  })), _react.default.createElement(_Quips.default, null), _react.default.createElement(_LoadingDots.default, null))));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/LoadingPage.js
// module id = 292
// module chunks = 0